const basePath = "/:prefix/products/:vbid";

export const productRoutes = {
  // Do not use an index route. It will break my courses which calls this manually
  path: basePath,
  async lazy() {
    const { Component, loader, action } = await import("./lazyRoute.ts");
    return { Component, loader, action };
  },
  children: [
    {
      path: `marketplace/:sku`,
      async lazy() {
        const { marketplaceLoader } = await import("./lazyRoute.ts");
        return { loader: marketplaceLoader };
      },
    },
  ],
};
